import {
  registerDecorator,
  ValidationOptions,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';

export function ValidatePositive(validationOptions?: ValidationOptions) {
  return (object: any, propertyName: string) => {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: ValidatePositiveConstraint,
    });
  };
}

@ValidatorConstraint({ name: 'ValidatePositive' })
export class ValidatePositiveConstraint implements ValidatorConstraintInterface {
  validate(value: number) {
    return value > 0;
  }

  defaultMessage() {
    return 'Value must be greater than 0';
  }
}
